import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=32e05840&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=32e05840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e05840",
  null
  
)

export default component.exports